export default __webpack_public_path__ + "static/media/photo.1751aa47.png";